const SEARCH_API_URL = `/core/v2/search`;
const API_INDEXER_GROUP = parseInt(process.env.API_INDEXER_GROUP) || 10;
const FRESHY_RECIPE_URL = "https://cooking.freshy.com/recipe";
const FRESHY_LINK_TRACKING = { utm_source: "SearchFreshy", utm_medium: "serp" };

export {
    SEARCH_API_URL,
    API_INDEXER_GROUP,
    FRESHY_RECIPE_URL,
    FRESHY_LINK_TRACKING,
};
